/*
 * Post-category.ts
 * Description: Includes the declaration
 * of the function for creating a category
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Category} from '@/ts/categories/validate-category';

/**
 * Creating a category
 *
 * @return {Object} Promise - created category
 * @param {Category} data - category data
 * @param {String} slug - id of a restaurant
 */
export function postCategory(data: Category, slug: string) {
    const jwt = localStorage.getItem('jwt');
    data.order = 0;
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/menu-categories',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
